export const NumberThreeIcon = () => {
    return (
        <svg
            width="100"
            height="130"
            viewBox="0 0 100 130"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2278_16203)">
                <path
                    d="M38.2167 130C29.1722 130 20.3111 128.718 11.6333 126.155C3.07778 123.469 -4.13333 119.808 -10 115.169L0.266667 96.6761C4.91111 100.46 10.5333 103.512 17.1333 105.831C23.7333 108.15 30.6389 109.31 37.85 109.31C46.4056 109.31 53.0667 107.601 57.8333 104.183C62.6 100.643 64.9833 95.8826 64.9833 89.9014C64.9833 84.0423 62.7833 79.4038 58.3833 75.9859C53.9833 72.5681 46.8944 70.8592 37.1167 70.8592H25.3833V54.5634L62.05 10.9859L65.1667 19.9578H-3.76667V0H83.6833V15.9296L47.0167 59.507L34.55 52.1831H41.7C57.4667 52.1831 69.2611 55.723 77.0833 62.8028C85.0278 69.7606 89 78.7324 89 89.7183C89 96.9202 87.1667 103.573 83.5 109.676C79.8333 115.779 74.2111 120.723 66.6333 124.507C59.1778 128.169 49.7056 130 38.2167 130Z"
                    fill="#F3F5F7"
                />
            </g>
            <defs>
                <clipPath id="clip0_2278_16203">
                    <rect width="100" height="130" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
